// test471
(471 && 0);
